const t = {
  name: "Types",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.00038 -0.00378418L11.9822 11H0.0185547L6.00038 -0.00378418ZM3.3822 8.99999H8.61856L6.00038 4.18376L3.3822 8.99999Z" fill="currentColor"/>
<path d="M22.5 2H13.5V11H22.5V2ZM15.5 9V4H20.5V9H15.5Z" fill="currentColor"/>
<path d="M23.9943 18.01L18.0001 12.0157L12.0059 18.01L18.0001 24.0042L23.9943 18.01ZM18.0001 21.1757L14.8343 18.01L18.0001 14.8442L21.1659 18.01L18.0001 21.1757Z" fill="currentColor"/>
<path d="M6 13C3.23858 13 1 15.2386 1 18C1 20.7614 3.23858 23 6 23C8.76142 23 11 20.7614 11 18C11 15.2386 8.76142 13 6 13ZM3 18C3 16.3431 4.34315 15 6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Types
};
